export default __webpack_public_path__ + "static/media/cq_logo_primary.419f64dd.png";